<template>
  <div>
    <div class="header">
      <div class="header__top">
        <img src="https://zettains.ru/widget/ns-sport/img/logo-zetta.svg" alt="zetta-logo" class="header__logo">
        <a href="tel:88007006007" class="header__tel">8 800 700 60-07</a>
      </div>
      <div class="header__tittle">Калькулятор стоимости страхования спортсменов</div>
    </div>
    <div id="app" class="calculator container">
      <div class="calculator__left">
        <div class="dots-container">
            <div class="step-dots">
              <div class="step-dots__dot">
                <div class="step-dots__header">
                  <div class="step-dots__dot-number" :class="{ 'step-dots__active': $route.name === 'step1' }">1</div>
                  <div class="step-dots__dot-line"></div>
                </div>
                <div class="step-dots__dot-text">
                  Рассчет
                </div>
              </div>
              <div class="step-dots__dot">
                <div class="step-dots__header">
                  <div class="step-dots__dot-number" :class="{ 'step-dots__active': $route.name === 'step2' || $route.name === 'step3' || $route.name === 'step4' }">2</div>
                  <div class="step-dots__dot-line"></div>
                </div>
                <div class="step-dots__dot-text">
                  Оформление
                </div>
              </div>
              <div class="step-dots__dot">
                <div class="step-dots__header">
                  <div class="step-dots__dot-number">3</div>
                </div>
                <div class="step-dots__dot-text">
                  Оплата
                </div>
              </div>
          </div>
        </div>
        <router-view/>  
        <div v-if="$route.name == 'step4'" class="summary__content">
            <div class="step__text-summ">Стоимость полиса {{totalCost | numeric}} ₽</div>
            <div class="summary__buttons">
            <a v-if="$route.name == 'step4'" href="#" class="button button_width_full" :class="{disabled: buttonIsDisabled}"  @click.prevent="sendData">
              <span v-if="!isLoading">
                ОПЛАТИТЬ
              </span>
              <img v-else class="preloader" src="img/preloader-light-color.svg" alt="">
            </a>
              <a class="button button_type" href="#" @click.prevent="handleClickPrev"><-</a>
            </div>
          </div>
        
      </div>
      <div class="calculator__right">
        <div class="summary">
          <div class="summary__title">
            Страховка от несчастных случаев при занятиях спортом является незаменимым инструментом, который обеспечивает покрытие финансовых расходов в случае возникновения непредвиденных обстоятельств. На случай растяжений, вывихов и прочих травм. Покрытие можно выбрать до 500 000₽, а сам полис действует по всему миру.

          </div>
          <app-input @input="checkPromo" class="calculator__promocode" :field.sync="promocode"  :input="schema.promocode" />
          <div class="summary__price">
            {{totalCost | numeric}} ₽
          </div>
          <div class="summary__from-price">
            От 70₽ в год
          </div>
          <div class="summary__desc">
            Для оформления полиса онлайн вам потребуются данные паспорта страхователя и даты рождения застрахованных
          </div>
   

        
          
          <!-- <a v-else href="#" class="button button_width_full"  @click.prevent="nextStep">
            <span v-if="!isLoading">
              Далее
            </span>
            <img v-else class="preloader" src="img/preloader-light-color.svg" alt="">
          </a> -->
        </div>
        <div class="summery-links">
          <a href="https://zettains.ru/upload/rules/pravila-ns-ao-na-sayt.pdf" class="summery-links__link" target="_blank">
            Правила страхования
          </a>
          <a href="https://zettains.ru/widget/ns-sport/example_ns-sport.pdf" class="summery-links__link" target="_blank">
            Пример полиса
          </a>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer__text">
        АО «Зетта Страхование» специализируется на обслуживании физических и юридических лиц. В соответствии с Лицензиями ЦБ РФ СИ №0290, СЛ №0290, ОС №0290-03 от 23.05.2024, ОС №0290-04, ОС №0290-05, ПС №0290 от 06.06.2023 г. и от 06.06.2023 г. Компания предоставляет более 90 программ страхования и перестрахования..
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  
</style>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { mapFields } from 'vuex-map-fields';
  import AppInput from '@/components/Input.vue'
  export default {
    components:{
      AppInput
    },
    created() {
      this.$router.replace('/')
    },
    data(){
      return {
        count:2

      }
    },
    methods:{
      handleClickPrev(){
			this.$router.push({name:'step3'})
		},
      checkPromo(){
        this.checkPromocode();
      },
      sendData(){
        this.$validator.validate().then(valid => {
          if (valid && !this.buttonIsDisabled && !this.isLoading) {
            this.$store.dispatch('sendData');
          }
        });

      },
      
      nextStep(){
        this.$children[0].$refs.buttonNext.click();

        // this.$validator.validateAll().then(valid => {
        //   if (valid) {
        //     this.$router.push({name:`step${this.count}`})
        //   }
        // });
        
      },
      ...mapActions([
          'checkPromocode'
      ])
    },
    computed:{
      ...mapFields([
        'isLoading',
        'promocode',
        'promocodeAmount',
      ]),
      ...mapGetters({
        schema: 'getSchema',
        getTotalCost: 'getTotalCost',
        selectedSports:'getSelectedSports',
        sportTariffs: 'getSportTariffs',
        sum:'getSum',
        sports:'getSelectedSports',
        term:'getTerm',
        peopleCount:'getCount',
        maxCategory:'getMaxCategory',
        buttonIsDisabled:'getButtonIsDisabled',
        mail:'getMail',
        phone:'getPhone',
        polisDate:'getPolisDate',
      }),
      totalCost(){
        const {sportTariffs, selectedSports, sum, sports, term, peopleCount, promocodeAmount} = this
        let category = 1;
        let cost = '';
        let discountValue = 0;
        if(selectedSports.length){
          selectedSports.forEach((el) => {
            if(parseInt(el.UF_CATEGORY) > category) {
              category = parseInt(el.UF_CATEGORY);
            }
          })
          cost = sportTariffs[sum.value][category][term.value].premium*peopleCount.value;
          discountValue = cost * promocodeAmount;
          const costWithDiscount = Math.floor10(cost - discountValue, 0);
          this.$store.commit('setTotalCost', cost)
          // this.$store.commit('setTotalCost', costWithDiscount)
          return costWithDiscount;
        }
      },
      buttonDisabled(){
        // if()
      }
    },
    watch:{

    }
  }
</script>

<style lang="scss">



.button_type {
	min-width: 54px;
	padding: 0 !important;
	height: 54px !important;
	width: 54px !important;
	border: solid #b9b9b9 1px !important;
    color: #6C6F71 !important;
    font-weight: 500 !important;
    font-size: 17px !important;
    background-color: #ecf1f7 !important;
}
  body {
    font-family: Inter, "Open Sans", sans-serif;
    display: flex;
    font-variation-settings:
    "wdth" 75;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #303030;
    background-color: #f5f5f5;
  }
  * {
    box-sizing:border-box;
  }
  .footer {
    margin: 50px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .footer__text {
    max-width: 800px;
    font-size: 13px;
    color: #848199;
  }
  .dots-container {
    margin: 30px 0 0 30px;
    display: flex;
    align-items: center;
  }
  .step-dots {
    display: flex;
    &__dot-text {
      margin-top: 10px;
      font-size: 14px;
      text-align: start;
    }
    &__header {
      display: flex;
      align-items: center;
    }
    &__dot {
      display: flex;
   
     
      flex-direction: column;
      width: 100%;
    }
    &__dot-number {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      width: 35px !important;
      height: 35px !important;
      background-color: #DDF3F4;
      color: white;
    }
    &__dot-line {
      height: 1px;
      width: 100px;
      background-color: #DDF3F4;
    }

    &__active {
      background-color: #00b5c2 !important;
    }
  }
  .container {
    max-width: 800px;
    margin:0 auto;
  }
  .header {
    margin-top: 30px;
    max-width: 800px;
    &__top {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__tittle {
      font-size: 32px;
      color: #303030;
      font-weight: 500;
      margin: 40px 0;
    }
    &__tel {
      font-weight: 600;
      color: #303030;
      text-decoration: none;
      font-size: 28px;
    }
  }
  .calculator {
    display: flex;
    min-height: 200px;
    background-color: #ffffff;
    border-radius: 15px;
    
    &__left {
      width: 65%;
    }
    &__right {
      border-top-right-radius: 15px;
      border-bottom-right-radius: 15px;
      padding: 30px 20px 20px;
      background-color: #d9f9ef;
      width: 35%;

    }

    &__promocode {
      margin-bottom: 10px;
    }
    &__promocode input {
      background-color: #ffffff;
    }
  }
  .summary {
    &__desc {
      color: #4E4E4E;
      margin: 20px 0;
      font-size: 14px;
      line-height: 1.7;
    }
    &__from-price {
      font-size: 14px;
    }
    min-height: 251px;
    background-size: contain;
    &__title {
      color:$subcolor;
      font-size: 14px;
      line-height: 1.7;
      margin-bottom: 30px;
      
    }
    &__price {
      padding: 20px 0;
      font-size: 45px;
      font-weight: 700;
      color:$subcolor;
    }
    &__buttons {
      display: flex;
      flex-direction: row-reverse;
      gap: 15px;
      margin: 0 0 30px 30px;
      max-width: 440px;
    }
  }

      
  .summery-links {
    display: flex;
    flex-direction: column;
    justify-content:space-between;
    &__link {
      color:#808080;
      text-decoration: none;
      font-size: 12px;
      margin: 2.5px 0;
    }
  }

  .preloader {
    height: 25px;
  }

  @media (max-width: 1024px) {
  .step {
    &__list {
      padding-right: 0 !important;
    }
  }
  .summary__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #cbeaed;
    width: 100%;
    left: 0;
    position: fixed;
    bottom: 0;
    z-index: 10;
  }
  .summary__buttons {
    margin: 0;
    width: 100%;
    max-width: 740px;
    display: flex;
    gap: 15px;
    padding: 0 0 10px 0 !important;
    flex-direction: row-reverse !important;
  }

    .header,.footer {
      padding: 0 20px;
    }
    .calculator {
      flex-direction: column;
      
      &__left, &__right {
        width: 100%;
      }
      
      &__right {
        background-color: #ecf1f7;
        border-radius: 0 0 15px 15px;
      }
    }
    
    .header {
      &__tittle {
        font-size: 24px;
        margin: 20px 0;
      }
      
      &__tel {
        font-size: 20px;
      }
    }
    .button {
      &_width_full {
			max-width: unset !important;
			}
    }
  }

  @media (max-width: 768px) {
    .header {
      &__tittle {
        font-size: 20px;
      }
      
      &__tel {
        font-size: 18px;
      }
    }
    

    
    .summary {
      &__price {
        font-size: 36px;
      }
    }
  }

  @media (max-width: 480px) {
    .header {
      &__top {
  
      }
      
      &__tittle {
        font-size: 18px;
      }
    }
    
    .step-dots {
      &__dot-text {
        font-size: 12px;
      }
      
      &__dot-number {
        width: 30px !important;
        height: 30px !important;
      }
      
      &__dot-line {
        width: 60px;
      }
    }
  }
</style>